import { FETCH_HOUSES__SUCCESS } from '../constants';

export const initialState = [];

export default (state = initialState, { type, payload }) => (type === FETCH_HOUSES__SUCCESS ? payload.houses : state);
